import React from 'react';
import TextField from '@material-ui/core/TextField';
import { Button, Grid, Table } from 'semantic-ui-react';
import $ from "jquery";


import MakeDecimalPoint from '../../makedecimalpoints';
import Permission from '../../../functions/permission';
import getFormatedDate from '../../../functions/date';
import Server from '../../../functions/server';
import HSNReport from './HSNReport';
import Loading from '../../loading';
import Title from '../../title';


class GSTReport extends React.Component {

  state = {
    fromDate: getFormatedDate(new Date()),
    toDate: getFormatedDate(new Date()),
    data: [], branchOption: [], branchId: 'ALL',
    dropDown: 'ALL', dropdowngstin: 'ALL', menuPermission: []
  }

  componentDidMount() {
    this.menuControl();
  }

  menuControl() {
    let menuPermission = Permission('gst-sales-report', this.props.menus);
    if (menuPermission.view) {
      this.getBranch();
    }
    this.setState({ menuPermission })
  }

  // Get All Branch Name
  getBranch() {
    let context = this;
    context.setState({ load: true, message: 'Getting Branchs' });
    $.ajax({
      type: 'POST',
      url: Server() + 'branchdetails/getallbranchs.php',
      success: function(data) {
        try {
          data = JSON.parse(data);
          context.setState({ load: false, branchOption: data });
        } catch (e) {
          context.setState({ load: false });
        }
      },
      error: function(e) {
        alert('Try again!!')
        context.setState({ load: false });
      }
    });
  }

  // Get Sales Gst Report
  getGstReport = () => {
    let context = this;
    this.setState({ load: true, message: 'Getting GST REPORT!!!!' })
    $.ajax({
      type: 'POST',
      data: { 'from_date': context.state.fromDate, 'to_date': context.state.toDate,
              'branch_id': context.state.branchId, 'dropdowngstin': context.state.dropdowngstin },
      url: Server() + 'Accountings/GSTSalesReport/Get.php',
      success: function(data) {
        console.log(data);
        try {
          data = JSON.parse(data);
          data.map((c) => {
            c.backgroundColor = "white";
          })
          context.setState({ data: data, load: false })
        } catch (e) {
          alert('Error to get Data!!!');
          context.setState({ load: false })
        }
      },
      error: function (e) {
        context.setState({ load: false });
      }
    });
  }

  removePercentage(value) {
    try {
      value = value.split('%')[0];
    } catch (e) {
      value = 0.00;
    }
    return value;
  }

  fullTax(value) {
    value = this.removePercentage(value);
    return 'GST@'+value+'%';
  }

  fullTaxIGST(value) {
    value = this.removePercentage(value);
    return 'IGST@'+value+'%';
  }

  fullTaxIGSTVALUE(value) {
    value = this.removePercentage(value);
    return 'IGST @'+value+'%';
  }

  halfTax(value, type) {
    value = this.removePercentage(value); value = value/2;
    return type+' @'+value+'%';
  }

  getRow(cc) {
    let nonTaxableAmount = 0;
    let taxableAmount = 0;
    let taxAmount = 0;
    let tcsamount = 0.00;
    let i;
    let row = [];
    let overalltotal = 0;
    let lengthItem = 0;
    lengthItem = Object.keys(cc).length;
    lengthItem = lengthItem - 6;
    let tax = 0;
    if (Object.values(cc)[2] == 'Tamil Nadu') {
      for (i = 0; i < lengthItem; i++) {
        let total = this.convertToNumber(Object.values(cc)[i + 5]);
        tax = this.separateTax(Object.keys(cc)[i + 5]);
        if (tax == 0.1) {
          overalltotal = overalltotal + (((total * tax)/100));
          tcsamount = ((total * tax)/100);
        }
        else {
          overalltotal = overalltotal + (total + ((total * tax)/100));
          
          if (tax) {
            taxableAmount = taxableAmount + total;
          }
          else {
            nonTaxableAmount = nonTaxableAmount + total;
          }
          
          taxAmount = taxAmount + ((total * tax)/100);
        }
        if (Object.keys(cc)[i + 5] != '0.1%') {
          row.push(<Table.Cell><div style={{textAlign: 'right'}}>{this.taxableAmount(Object.values(cc)[i + 5], Object.keys(cc)[i + 5])}</div></Table.Cell>);
          row.push(<Table.Cell><div style={{textAlign: 'right'}}>{this.taxAmount(Object.values(cc)[i + 5], Object.keys(cc)[i + 5], 2)}</div></Table.Cell>);
          row.push(<Table.Cell><div style={{textAlign: 'right'}}>{this.taxAmount(Object.values(cc)[i + 5], Object.keys(cc)[i + 5], 2)}</div></Table.Cell>);
        }
      }
      for (var ii = 0; ii < lengthItem; ii++) {
        if (Object.keys(cc)[ii + 5] != '0.1%') {
          row.push(<Table.Cell><div style={{textAlign: 'right'}}>{'0.00'}</div></Table.Cell>);
          row.push(<Table.Cell><div style={{textAlign: 'right'}}>{'0.00'}</div></Table.Cell>);
        }
      }
    }
    else {
      for (let ii = 0; ii < lengthItem; ii++) {
        if (Object.keys(cc)[ii + 5] != '0.1%') {
          row.push(<Table.Cell><div style={{textAlign: 'right'}}>{'0.00'}</div></Table.Cell>);
          row.push(<Table.Cell><div style={{textAlign: 'right'}}>{'0.00'}</div></Table.Cell>);
          row.push(<Table.Cell><div style={{textAlign: 'right'}}>{'0.00'}</div></Table.Cell>);
        }
      }
      for (i = 0; i < lengthItem; i++) {
        let total = this.convertToNumber(Object.values(cc)[i + 5]);
        tax = this.separateTax(Object.keys(cc)[i + 5]);
        overalltotal = overalltotal + (total + ((total * tax)/100));
        if (tax == 0.1) {
          overalltotal = overalltotal + (((total * tax)/100));
          tcsamount = ((total * tax)/100);
        }
        else {
          overalltotal = overalltotal + (total + ((total * tax)/100));
          if (tax) {
            taxableAmount = taxableAmount + total;
          }
          else {
            nonTaxableAmount = nonTaxableAmount + total;
          }
          taxAmount = taxAmount + ((total * tax)/100);
        }
        
        if (Object.keys(cc)[i + 5] != '0.1%') {
          row.push(<Table.Cell><div style ={{textAlign: 'right'}}>{this.taxableAmount1(Object.values(cc)[i + 5], Object.keys(cc)[i + 5])}</div></Table.Cell>);
          row.push(<Table.Cell><div style={{textAlign: 'right'}}>{this.taxAmount(Object.values(cc)[i + 5], Object.keys(cc)[i + 5], 1)}</div></Table.Cell>);
        }
      }
      overalltotal = overalltotal / 2;
    }
    overalltotal = this.convertToNumber(overalltotal);
    overalltotal = Math.round(overalltotal);
    row.push(<Table.Cell><div style={{textAlign: 'right'}}>{MakeDecimalPoint(taxableAmount)}</div></Table.Cell>);
    row.push(<Table.Cell><div style={{textAlign: 'right'}}>{MakeDecimalPoint(nonTaxableAmount)}</div></Table.Cell>);
    row.push(<Table.Cell><div style={{textAlign: 'right'}}>{MakeDecimalPoint(taxAmount)}</div></Table.Cell>);
    row.push(<Table.Cell><div style={{textAlign: 'right'}}>{MakeDecimalPoint(tcsamount)}</div></Table.Cell>);
    row.push(<Table.Cell><div style={{textAlign: 'right'}}>{overalltotal}</div></Table.Cell>);
    return row;
  }

  convertToNumber(value) {
    try {
      value = Number(value);
    } catch (e) {
      value = 0.00;
    }
    return value;
  }

  separateTax(tax) {
    tax = tax.split('%')[0];
    tax = this.convertToNumber(tax);
    return tax;
  }

  taxAmount(value, tax, division) {
    value = this.convertToNumber(value);
    tax = tax.split('%')[0];
    tax = this.convertToNumber(tax);
    value = ((value * tax)/100)/division;
    try {
      value = value.toFixed(2);
    } catch (e) {
      value = 0.00;
    }
    return value;
  }

  taxableAmount1(value, tax) {
    value = this.convertToNumber(value);
    tax = tax.split('%')[0];
    tax = this.convertToNumber(tax);
    try {
      value = value.toFixed(2);
    } catch (e) {
      value = 0.00;
    }
    return value;
  }

  taxableAmount(value, tax) {
    value = this.convertToNumber(value);
    tax = tax.split('%')[0];
    tax = this.convertToNumber(tax);
    try {
      value = value.toFixed(2);
    } catch (e) {
      value = 0.00;
    }
    return value;
  }

  export = () => {
    let downloadLink;
    let filename = 'GstReport';
    let dataType = 'application/vnd.ms-excel';
    let tableSelect = document.getElementById('export');
    let tableHTML = tableSelect.outerHTML.replace(/ /g, '%20');
    filename = filename?filename+'.xls':'excel_data.xls';
    downloadLink = document.createElement("a");
    document.body.appendChild(downloadLink);
    if(navigator.msSaveOrOpenBlob) {
      let blob = new Blob(['\ufeff', tableHTML], {
          type: dataType
      });
      navigator.msSaveOrOpenBlob( blob, filename);
    }
    else {
      downloadLink.href = 'data:' + dataType + ', ' + tableHTML;
      downloadLink.download = filename;
      downloadLink.click();
    }
  }

  selectBranch = event => {
    let value = event.target.value;
    if (value == 'ALL') {
      this.setState({ dropDown: value, branchId: value })
    }
    else {
      let branchId = value.split('->')[0];
      let branchName = value.split('->')[1];
      this.setState({ branchId, dropDown: branchName })
    }
  }

  selectGstin = event => {
    this.setState({ dropdowngstin: event.target.value })
  }

  selectedRow(voucherno) {
    let data = this.state.data;
    data.map((c) => {
      if (c.invoice_voucher == voucherno) {
        if (c.backgroundColor == '#8AD65B') {
          c.backgroundColor = 'white';
        }
        else {
          c.backgroundColor = '#8AD65B';
        }
      }
      else {
        c.backgroundColor = 'white';
      }
    })
    this.setState({ data })
  }

  render() {
    let count = 0;
    let sino = 1;
    return (
      <div>
        <Title title='GST SALES REPORT' openDrawer={this.props.openDrawer}/>
        {
          this.state.menuPermission.view ? 
            (
<div style={{padding: '0.5%'}}>
          <Grid>
            <Grid.Column mobile={16} tablet={16} computer={16}>
              <div style={{float: 'left', display: 'flex'}}>
                <TextField label="From" type="date"
                  onChange={(e) => this.setState({fromDate: e.target.value})}
                  defaultValue={this.state.fromDate} />
                <TextField style={{marginLeft: 20}} label="To" type="date"
                  onChange={(e) => this.setState({toDate: e.target.value})}
                  defaultValue={this.state.toDate} />
                <div style={{marginLeft:20, marginTop: '1%'}}>
                  <datalist id="branchs">
                      <option>ALL</option>
                      {this.state.branchOption.map((c) => {
                        return (<option id='box'>{c.id+'->'+c.name}</option>)
                      })}
                  </datalist>
                  <input style={{height: 35, width: '100%'}} onChange={this.selectBranch} autoComplete="on"
                  list="branchs" value={this.state.dropDown} />
                </div>
                <div style={{marginLeft:20, marginTop: '1%'}}>
                  <datalist id="GST">
                      <option>ALL</option>
                      <option>GSTIN AVAILABLE CUSTOMER</option>
                      <option>GSTIN NOT AVAILABLE CUSTOMER</option>
                  </datalist>
                  <input style={{height: 35, width: '100%'}} onChange={this.selectGstin} autoComplete="on"
                  list="GST" value={this.state.dropdowngstin} />
                </div>
                <Button variant="contained" color="primary" style={{marginLeft:20, marginTop: '1%'}} onClick={this.getGstReport}>Go</Button>
                { this.state.menuPermission.exports ?
                  (
                    <Button variant="contained" color="primary" style={{marginLeft:20, marginTop: '1%'}} onClick={this.export}>
                      Export
                    </Button>
                  ):''
                }
                <div style={{marginLeft:20, marginTop: '1%'}}>
                  <HSNReport />
                </div>
              </div>
            </Grid.Column>
            <Grid.Column mobile={16} tablet={16} computer={16}>
              <div style={{overflow: 'auto', overflow: 'scroll', width: '98vw', height: '95vh' }}>
                <Table celled singleLine id='export'>
                  <Table.Header>
                    <Table.Row>
                      <Table.HeaderCell id='tableheader'>Sino</Table.HeaderCell>
                      <Table.HeaderCell id='tableheader'>Voucher</Table.HeaderCell>
                      <Table.HeaderCell id='tableheader'>Date</Table.HeaderCell>
                      <Table.HeaderCell id='tableheader'>Customer</Table.HeaderCell>
                      <Table.HeaderCell id='tableheader'>State</Table.HeaderCell>
                      <Table.HeaderCell id='tableheader'>GSTIN</Table.HeaderCell>
                      {
                        this.state.data.map((c) => {
                          let lengthItem = Object.keys(c).length;
                          lengthItem = lengthItem - 6;
                          let row = [];
                          if (count == 0) {
                            for (var i = 0.00; i < lengthItem; i++) {
                              if (Object.keys(c)[i + 5] != '0.1%') {
                                row.push(<Table.HeaderCell id='tableheader'>{this.fullTax(Object.keys(c)[i + 5])}</Table.HeaderCell>);
                                row.push(<Table.HeaderCell id='tableheader'>{this.halfTax(Object.keys(c)[i + 5], 'CGST')}</Table.HeaderCell>);
                                row.push(<Table.HeaderCell id='tableheader'>{this.halfTax(Object.keys(c)[i + 5], 'SGST')}</Table.HeaderCell>);
                              }
                            }
                            for (var i = 0.00; i < lengthItem; i++) {
                              if (Object.keys(c)[i + 5] != '0.1%') {
                                row.push(<Table.HeaderCell id='tableheader'>{this.fullTaxIGST(Object.keys(c)[i + 5])}</Table.HeaderCell>);
                                row.push(<Table.HeaderCell id='tableheader'>{this.fullTaxIGSTVALUE(Object.keys(c)[i + 5])}</Table.HeaderCell>);
                              }
                            }
                            row.push(<Table.HeaderCell id='tableheader'>{'Taxable Amount'}</Table.HeaderCell>);
                            row.push(<Table.HeaderCell id='tableheader'>{'Non Taxable Amount'}</Table.HeaderCell>);
                            row.push(<Table.HeaderCell id='tableheader'>{'Tax Amount'}</Table.HeaderCell>);
                            row.push(<Table.HeaderCell id='tableheader'>{'TCS (0.1%)'}</Table.HeaderCell>);
                            row.push(<Table.HeaderCell id='tableheader'>{'Total'}</Table.HeaderCell>);
                          }
                          count++;
                          return row;
                        })
                      }
                    </Table.Row>
                  </Table.Header>
                  {
                    this.state.data.map((cc) => {
                      let GSTIN = cc.GSTIN;
                      if (!GSTIN) {
                        GSTIN = 'Not Available';
                      }
                      return (
                        <Table.Body style={{backgroundColor: cc.backgroundColor, cursor: 'pointer'}}>
                        <Table.Row onClick={this.selectedRow.bind(this, cc.invoice_voucher)}>
                          <Table.Cell>{sino++}</Table.Cell>
                          <Table.Cell width={10}>{cc.invoice_voucher}</Table.Cell>
                          <Table.Cell>{this.dateFormate(cc.timestamp)}</Table.Cell>
                          <Table.Cell>{cc.name}</Table.Cell>
                          <Table.Cell>{cc.state}</Table.Cell>
                          <Table.Cell>{GSTIN}</Table.Cell>
                          {this.getRow(cc)}
                        </Table.Row>
                        </Table.Body>
                      )
                    })
                  }
                </Table>
              </div>
            </Grid.Column>
          </Grid>
        </div>
            ):(<center>You Are Not Allow To Access This Menu!!!</center>)
        }
        <Loading load={this.state.load} message={this.state.message} />
      </div>
    );
  }

  dateFormate(value) {
    let date = value.split(' ')[0];
    date = date.split('-')[2]+'-'+date.split('-')[1]+'-'+date.split('-')[0];
    return date;
  }
}

export default GSTReport;
